var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26827 14C0.498482 15.3333 1.46073 17 3.00033 17H18C19.5396 17 20.5019 15.3333 19.7321 14L12.2322 1.00968C11.4624 -0.323671 9.5379 -0.323672 8.76811 1.00968L1.26827 14ZM11.4969 13.002C11.4969 13.5525 11.0506 14.0015 10.5002 14.0015C9.94969 14.0015 9.50345 13.5525 9.50345 13.002C9.50345 12.4516 9.94969 12.0025 10.5002 12.0025C11.0506 12.0025 11.4969 12.4516 11.4969 13.002ZM10.5002 11.003C11.0506 11.003 11.4969 10.5568 11.4969 10.0063V7.00228C11.4969 6.45181 11.0506 6.00557 10.5002 6.00557C9.94969 6.00557 9.50345 6.45181 9.50345 7.00229V10.0063C9.50345 10.5568 9.94969 11.003 10.5002 11.003Z",
    fill: "#ffca63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.9c743f2c836d03eaa13c870f8854b90c.svg";
export { ForwardRef as ReactComponent };